<template>
  <section
    class="Modal ModalConfirm"
    @click.self="closeModal"
    v-if="showModal"
    :class="{ display: showModal }"
    ref="calendar"
  >
    <div class="Modal-inner">
      <div class="Modal-header">
        <span @click="closeModal" class="mobileOnly">fermer</span>
        <div class="Modal-close" @click="closeModal">
          <svg v-svg symbol="Close" size="0 0 16 16" role="presentation" class="icon--inline"></svg>
        </div>
      </div>
      <div class="Modal-content">
        <Richtext :text="content"></Richtext>
      </div>
      <div class="Modal-confirmButton">
      <button class="Button Button-success" @click="updateConsents">Confirmer</button>
      <button class="Button Button-danger" @click="closeModal">Annuler</button>
      </div>
    </div>
  </section>
</template>

<script>
import Richtext from "@/components/Richtext/Richtext.vue";

import "@/components/Modal/Modal.scss";

export default {
  name: "ModalConfirm",

  components: {
    Richtext,
  },

  props: {
    showModal: Boolean,
    content: String,
  },

  methods: {
    closeModal () {
      return this.$emit("Modal::close");
    },

    updateConsents () {
      return this.$emit("Modal::update");
    },
  },
};
</script>
